<template>
  <div class="goods">
    <div v-if="show">
      <div class="goods-imgs">
        <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
          <van-swipe-item v-for="(img, index) in goods.image" :key="index"><img :src="img.file.full_url" width="100%" /></van-swipe-item>
        </van-swipe>
      </div>
      <div class="goods-p-t">
        <div class="goods-price" v-if="isPriceShow"><span class="p-1">￥{{ goods.sell_price }}</span><span class="p-2">零售价 </span><span class="p-3"><van-stepper v-model="purchases" :step="goods.purchases_num" :min="goods.purchases_num" disable-input /></span></div>
        <h3 class="g-title">{{ goods.goods_name }}</h3>
        <div class="g-inventory">
          <span class="left">运费：包邮</span>
          <span class="right">库存：{{ goods.stock_num }}</span>
        </div>
      </div>
      <!--
      <div class="goods-address">
        <van-cell class="g-a-title" is-link readonly clickable title="送至" :value="address" @click="bindShow" />
        <van-popup v-model="showArea" position="bottom" :style="{ height: '40%' }">
          <van-area :area-list="areaList" @confirm="onAreaConfirm" @cancel="bindCancel" />
        </van-popup>
      </div>
      -->
      <div class="goods-show">
        <h3 class="h3">商品详情</h3>
        <div class="content" v-html="goods.content"></div>
      </div>
      <van-goods-action>
        <van-goods-action-icon icon="shop-o" text="主页" @click="onClickIndex" />
        <van-goods-action-button
          type="danger"
          text="立即购买"
          @click="onClickButton"
        />
      </van-goods-action>
    </div>
    <Laod ref="laoding" />
  </div>
</template>

<script>
  import { Swipe, SwipeItem, GoodsAction, GoodsActionIcon, GoodsActionButton, Stepper, Area, Popup, Cell  } from 'vant';
  import AeraInfo from "../../assets/area/area.js"
  //import wx from 'weixin-jsapi'
  import wx from 'weixin-js-sdk'

  export default {
    components: {
      [Stepper.name]: Stepper,
      [Swipe.name]: Swipe,
      [SwipeItem.name]: SwipeItem,
      [GoodsAction.name]: GoodsAction,
      [GoodsActionIcon.name]: GoodsActionIcon,
      [GoodsActionButton.name]: GoodsActionButton,
      [Area.name]: Area,
      [Popup.name]: Popup,
      [Cell.name]: Cell
    },
    name: 'goods_details',
    data() {
      return {
        show: false,
        purchases: 1,
        address: '请选择所在地区',
        goods: [],
        areaList: AeraInfo, //引用地区信息
        showArea: false,
        valueArea: '', //地区值
        arrArea: [], //存放地区数组
        link: '',
        userInfo: this.$store.state,
        isPriceShow: false
      };
    },
    created() {
      if(this.$route.query.hid){
        localStorage.setItem('hid', this.$route.query.hid)
      }else{
        localStorage.setItem('hid', 0)
      }
      this.getDetails()
    },
    methods: {
      getJssdkConfig(apis, debug, json, link){
        let self = this
        this.$api.get('jssdkConfig', {apis:apis, debug:debug, json:json, url: link}, r=>{
          let config = JSON.parse(r.data)
          wx.config(config);
          wx.ready(function() {
            let shareData = {
              title: self.goods.goods_name,
              desc: '沃隆多肽倍护精华液套盒',
              link: self.link,
              imgUrl: self.goods.image[0].file.full_url,
              success: function () {}
            }
            wx.showOptionMenu()
            wx.updateAppMessageShareData(shareData)
            wx.updateTimelineShareData(shareData)
          })
          wx.error(function(error){
            //console.log(error)
          })
        })
      },
      getDetails() {
        const regex = new RegExp('<img', 'gi')
        this.$api.get('goods/details', {id: 4}, r=>{
          this.goods = r.data
          this.purchases = r.data.purchases_num
          let content = this.goods.content
          this.goods.content = content.replace(regex, `<img style="max-width: 100%; height: auto"`)
          this.link = process.env.DOMAIN_NAME+"goods/details?id="+this.goods.id+"&hid="+this.$store.state.hid;
          this.show = true
          this.$refs.laoding.loadClose()
          this.getJssdkConfig("checkJsApi,updateAppMessageShareData,updateTimelineShareData", false, false, window.location.href.split('#')[0]);
          if(this.userInfo.grade_id == 2 || this.userInfo.grade_id == 3){
            this.isPriceShow = true
          }
        })
      },
      onClickIndex() {
        this.$router.push('/');
      },
      onClickButton() {
        if(this.$store.state.grade_id === 3 || this.$store.state.grade_id === 2){
          this.$router.push({name:'payment', query:{goods_id:this.goods.id, purchases:this.purchases}});
        }else{
          this.$toast('只有VIP会员，代理商可购买该商品！')
          return
        }
      },
      bindShow(){
        this.showArea= true;
      },
      bindCancel(){
        this.showArea= false;
      },
      //地区选择
      onAreaConfirm(val) {
        this.showArea = false;
        this.arrArea = val;
        var addrInfo = val[0].name + '/' + val[1].name + '/' + val[2].name;
        this.address = addrInfo
      },
    },
  }
</script>

<style scoped>
  .goods{
    overflow: hidden;
  }
  .goods .goods-imgs{

  }
  .my-swipe .van-swipe-item {
    color: #fff;
    font-size: 20px;
    line-height: 150px;
    text-align: center;
    background-color: #39a9ed;
  }
  .goods .goods-imgs img{
    display: block;
  }
  .goods .goods-p-t{
    padding:15px;
    overflow: hidden;
    background: #ffffff;
  }
  .goods .goods-p-t .goods-price{
    overflow: hidden;
  }
  .goods .goods-p-t .goods-price span{
    float: left;
    margin-right: 10px;
  }
  .goods .goods-p-t .goods-price .p-1{
    color:#EC0018;
    font-size: 16px;
    font-weight: bold;
  }
  .goods .goods-p-t .goods-price .p-2{
    color:#9E9D9F;
    font-size: 12px;
    margin-top: 3px;
  }
  .goods .goods-p-t .goods-price .p-2 em{
    font-style: normal;
    text-decoration:line-through;
  }
  .goods .goods-p-t .goods-price .p-3{
    float: right;
    margin-right: 0;
  }
  .goods .goods-p-t .g-title{
    font-size: 14px;
    margin: 0;
    padding-top: 10px;
  }
  .goods .goods-p-t .g-inventory{
    font-size: 12px;
    color:#9E9D9F;
    margin-top: 10px;
  }
  .goods .goods-address{
    margin: 10px 0;
    overflow: hidden;
    background: #ffffff;
  }
  .goods .goods-address .g-a-title{
    color:#9E9D9F;
    font-size: 12px;
  }
  .goods .goods-show{
    margin-top:10px;
    overflow: hidden;
    background: #ffffff;
  }
  .goods .goods-show .h3{
    text-align: center;
    font-weight: normal;
    font-size: 15px;
  }
  .goods .goods-show .content{
    padding:15px 0;
  }
  .goods .goods-show .content img{
    display: block;
    max-width: 100% !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/goods/details.vue